'use client';
import {useCallback, useState} from 'react';

export const useToggle: (
  initialState?: boolean | (() => boolean)
) => [boolean, (value?: boolean) => void] = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const toggle = useCallback((value?: boolean) => {
    setIsOpen((prev) => (typeof value === 'boolean' ? value : !prev));
  }, []);

  return [isOpen, toggle];
};
